import React, { useState } from "react";
import Alert from "@mui/material/Alert";
import { alpha } from "@mui/material/styles";
import Button from "@components/Button/Button";
import { useTranslation } from "react-i18next";

const LANG_BASE = "vessel-nomination.dry-bulk.add";

interface ShortNoticeBannerProps {
  testId: string;
}

/** VN-04: display only; "OK, got it" hides it for the rest of the page visit. */
const ShortNoticeBanner: React.FC<ShortNoticeBannerProps> = ({ testId }) => {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <Alert
      severity="info"
      icon={false}
      sx={(theme) => ({
        backgroundColor: alpha(theme.palette.primary.main, 0.1),
        color: theme.palette.text.primary,
      })}
      data-testid={`${testId}-short-notice`}
      action={
        <Button
          variant="outlined"
          color="primary"
          label={t(`${LANG_BASE}.short-notice-dismiss`)}
          testId={`${testId}-short-notice-dismiss`}
          onClick={() => setDismissed(true)}
          sx={{ textTransform: "none" }}
        />
      }
    >
      {t(`${LANG_BASE}.short-notice`)}
    </Alert>
  );
};

export default ShortNoticeBanner;
